export default __webpack_public_path__ + "static/media/EKYCStatus@2x.5659c067.png";